import React, { useContext, useState } from 'react';
import { LanguageContext } from '../translations/LanguageContext';
import Footer from '../components/Footer';
import './PersonalHealthXAI.css';

// Interactive Onboarding Component
function InteractiveOnboarding({ translations }) {
  const [currentScreen, setCurrentScreen] = useState(1);
  const [userAnswers, setUserAnswers] = useState({
    q1: null,
    q2: null,
    q3: null,
    dailyHours: ''
  });

  const totalScreens = 7;

  const handleNext = () => {
    if (currentScreen < totalScreens) {
      setCurrentScreen(currentScreen + 1);
    }
  };

  const handlePrev = () => {
    if (currentScreen > 1) {
      setCurrentScreen(currentScreen - 1);
    }
  };

  const handleAnswerChange = (question, value) => {
    setUserAnswers(prev => ({
      ...prev,
      [question]: value
    }));
  };

  const handleRestart = () => {
    setUserAnswers({ q1: null, q2: null, q3: null, dailyHours: '' });
    setCurrentScreen(1);
  };

  const calculateCircles = () => {
    const hours = parseFloat(userAnswers.dailyHours) || 0;
    const lifeExpectancy = 80; // years
    const totalDays = lifeExpectancy * 365.25;
    const hoursPerDay = 24;
    const totalHours = totalDays * hoursPerDay;
    
    const socialMediaHours = hours * 365.25 * lifeExpectancy;
    const percentage = (socialMediaHours / totalHours) * 100;
    
    const totalCircles = 88; // 11x8 grid
    const socialMediaCircles = Math.round((percentage / 100) * totalCircles);
    
    return {
      total: totalCircles,
      socialMedia: socialMediaCircles,
      years: ((socialMediaHours / hoursPerDay) / 365.25).toFixed(2)
    };
  };

  const renderProgressDots = () => (
    <div className="phai-progress-dots">
      {[1, 2, 3, 4, 5, 6, 7].map(dot => (
        <span 
          key={dot} 
          className={`phai-dot ${currentScreen === dot ? 'active-dot' : ''}`}
        />
      ))}
    </div>
  );

  const renderScreen = () => {
    switch (currentScreen) {
      case 1:
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
            </div>
            <div className="phai-screen-body">
              <h2>{translations.onboardingScreens.welcome.title}</h2>
              <p>{translations.onboardingScreens.welcome.text1}</p>
              <p>{translations.onboardingScreens.welcome.text2}</p>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleNext}>
                {translations.onboardingScreens.welcome.button}
              </button>
            </div>
          </div>
        );
      
      case 2:
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
              <span className="phai-back-arrow" onClick={handlePrev}>‹</span>
            </div>
            <div className="phai-screen-body">
              <h2>
                {translations.onboardingScreens.q1.question}
                <span className="phai-info-icon" title="Mehr Informationen">i</span>
              </h2>
              <div className="phai-radio-group">
                {translations.onboardingScreens.q1.options.map((option, idx) => (
                  <label key={idx} className={userAnswers.q1 === option ? 'selected' : ''}>
                    <input
                      type="radio"
                      name="q1"
                      value={option}
                      checked={userAnswers.q1 === option}
                      onChange={() => handleAnswerChange('q1', option)}
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleNext}>
                {translations.onboardingScreens.continueBtn}
              </button>
            </div>
          </div>
        );
      
      case 3:
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
              <span className="phai-back-arrow" onClick={handlePrev}>‹</span>
            </div>
            <div className="phai-screen-body">
              <h2>
                {translations.onboardingScreens.q2.question}
                <span className="phai-info-icon" title="Mehr Informationen">i</span>
              </h2>
              <div className="phai-radio-group">
                {translations.onboardingScreens.q2.options.map((option, idx) => (
                  <label key={idx} className={userAnswers.q2 === option ? 'selected' : ''}>
                    <input
                      type="radio"
                      name="q2"
                      value={option}
                      checked={userAnswers.q2 === option}
                      onChange={() => handleAnswerChange('q2', option)}
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleNext}>
                {translations.onboardingScreens.continueBtn}
              </button>
            </div>
          </div>
        );
      
      case 4:
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
              <span className="phai-back-arrow" onClick={handlePrev}>‹</span>
            </div>
            <div className="phai-screen-body">
              <h2>
                {translations.onboardingScreens.q3.question}
                <span className="phai-info-icon" title="Mehr Informationen">i</span>
              </h2>
              <div className="phai-radio-group">
                {translations.onboardingScreens.q3.options.map((option, idx) => (
                  <label key={idx} className={userAnswers.q3 === option ? 'selected' : ''}>
                    <input
                      type="radio"
                      name="q3"
                      value={option}
                      checked={userAnswers.q3 === option}
                      onChange={() => handleAnswerChange('q3', option)}
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleNext}>
                {translations.onboardingScreens.continueBtn}
              </button>
            </div>
          </div>
        );
      
      case 5:
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
              <span className="phai-back-arrow" onClick={handlePrev}>‹</span>
            </div>
            <div className="phai-screen-body">
              <h2>{translations.onboardingScreens.results.title}</h2>
              <div className="phai-answer-list">
                <div className="phai-answer-item">
                  <p className="phai-answer-question">{translations.onboardingScreens.results.q1Label}</p>
                  <p className="phai-answer-user">{translations.onboardingScreens.results.yourAnswer} <strong>{userAnswers.q1 || translations.onboardingScreens.results.noAnswer}</strong></p>
                  <p className="phai-answer-correct">{translations.onboardingScreens.results.correctAnswer} <strong>{translations.onboardingScreens.results.q1Correct}</strong></p>
                </div>
                <div className="phai-answer-item">
                  <p className="phai-answer-question">{translations.onboardingScreens.results.q2Label}</p>
                  <p className="phai-answer-user">{translations.onboardingScreens.results.yourAnswer} <strong>{userAnswers.q2 || translations.onboardingScreens.results.noAnswer}</strong></p>
                  <p className="phai-answer-correct">{translations.onboardingScreens.results.correctAnswer} <strong>{translations.onboardingScreens.results.q2Correct}</strong></p>
                </div>
                <div className="phai-answer-item">
                  <p className="phai-answer-question">{translations.onboardingScreens.results.q3Label}</p>
                  <p className="phai-answer-user">{translations.onboardingScreens.results.yourAnswer} <strong>{userAnswers.q3 || translations.onboardingScreens.results.noAnswer}</strong></p>
                  <p className="phai-answer-correct">{translations.onboardingScreens.results.correctAnswer} <strong>{translations.onboardingScreens.results.q3Correct}</strong></p>
                </div>
              </div>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleNext}>
                {translations.onboardingScreens.continueBtn}
              </button>
            </div>
          </div>
        );
      
      case 6:
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
              <span className="phai-back-arrow" onClick={handlePrev}>‹</span>
            </div>
            <div className="phai-screen-body">
              <h2>{translations.onboardingScreens.timeInput.question}</h2>
              <div className="phai-time-input-group">
                <div className="phai-time-input-wrapper">
                  <input
                    type="number"
                    min="0"
                    max="24"
                    step="0.5"
                    className="phai-time-input"
                    value={userAnswers.dailyHours}
                    onChange={(e) => handleAnswerChange('dailyHours', e.target.value)}
                    placeholder="0"
                  />
                  <span className="phai-time-label">{translations.onboardingScreens.timeInput.unit}</span>
                </div>
              </div>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleNext}>
                {translations.onboardingScreens.continueBtn}
              </button>
            </div>
          </div>
        );
      
      case 7:
        const circleData = calculateCircles();
        return (
          <div className="phai-onboarding-screen">
            <div className="phai-screen-header">
              <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" className="phai-onboarding-logo" />
              <span className="phai-back-arrow" onClick={handlePrev}>‹</span>
            </div>
            <div className="phai-screen-body">
              <div className="phai-viz-container">
                <p className="phai-viz-subtitle">
                  {translations.onboardingScreens.visualization.subtitle}
                </p>
                <h2 className="phai-viz-result">
                  {circleData.years} {translations.onboardingScreens.visualization.yearsLabel}
                </h2>
                <p className="phai-viz-subtitle">
                  {translations.onboardingScreens.visualization.description}
                </p>
                <div className="phai-circles-grid">
                  {Array.from({ length: circleData.total }).map((_, index) => (
                    <div
                      key={index}
                      className={`phai-circle ${index < circleData.socialMedia ? 'social-media' : 'life'}`}
                    />
                  ))}
                </div>
                <div className="phai-legend">
                  <div className="phai-legend-item">
                    <div className="phai-legend-circle life"></div>
                    <span>{translations.onboardingScreens.visualization.lifeLegend}</span>
                  </div>
                  <div className="phai-legend-item">
                    <div className="phai-legend-circle social-media"></div>
                    <span>{translations.onboardingScreens.visualization.socialMediaLegend}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="phai-screen-footer">
              {renderProgressDots()}
              <button className="phai-primary-btn" onClick={handleRestart}>
                {translations.onboardingScreens.results.restartBtn}
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="phai-onboarding-container">
      {renderScreen()}
    </div>
  );
}

function PersonalHealthAI() {
  const { language, translations } = useContext(LanguageContext);
  const pageContent = translations[language].personalHealthAIPage;
  const [activeTab, setActiveTab] = useState('summary');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'summary':
        return (
          <div className="phai-tab-content">
            <div className="phai-tab-text">
              {pageContent.summaryTexts.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>
          </div>
        );
      case 'concept':
        return (
          <div className="phai-tab-content">
            <div className="phai-tab-text">
              {pageContent.conceptTexts.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>
          </div>
        );
      case 'development':
        return (
          <div className="phai-tab-content">
            <div className="phai-tab-text">
              {pageContent.developmentTexts.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="phai-page">
      {/* Hero Section */}
      <section className="phai-hero">
        <div className="phai-hero-content">
          <div className="phai-hero-text">
            <h1 className="phai-hero-title">{pageContent.heroTitle}</h1>
            <p className="phai-hero-subtitle">{pageContent.heroSubtitle}</p>
            <span className="phai-tech-badge">{pageContent.techBadge}</span>
          </div>
          <div className="phai-hero-image">
            <img src="/PersonalHealthXAI/dodont_logo.png" alt="DODONT Logo" />
          </div>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="phai-tabs-section">
        <div className="phai-tabs">
          <button
            className={`phai-tab ${activeTab === 'summary' ? 'active' : ''}`}
            onClick={() => setActiveTab('summary')}
          >
            {pageContent.tabSummary}
          </button>
          <button
            className={`phai-tab ${activeTab === 'concept' ? 'active' : ''}`}
            onClick={() => setActiveTab('concept')}
          >
            {pageContent.tabConcept}
          </button>
          <button
            className={`phai-tab ${activeTab === 'development' ? 'active' : ''}`}
            onClick={() => setActiveTab('development')}
          >
            {pageContent.tabDevelopment}
          </button>
        </div>
        <div className="phai-tab-container">
          {renderTabContent()}
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="phai-audience-section">
        <div className="phai-audience-content">
          <div className="phai-audience-text">
            <h2>{pageContent.audienceTitle}</h2>
            <p>{pageContent.audienceDescription}</p>
          </div>
          <div className="phai-audience-image">
            <img src="/PersonalHealthXAI/train.png" alt={pageContent.audienceImageAlt} />
          </div>
        </div>
      </section>

      {/* Related Topics Section */}
      <section className="phai-topics-section">
        <h2 className="phai-section-title">{pageContent.topicsTitle}</h2>
        <p className="phai-section-subtitle">{pageContent.topicsSubtitle}</p>
        <div className="phai-topics-grid">
          {pageContent.topicItems.map((item, index) => (
            <div key={index} className="phai-topic-card">
              <div className="phai-topic-image">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="phai-topic-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Problem Statement Section */}
      <section className="phai-problem-section">
        <h2 className="phai-section-title">{pageContent.problemTitle}</h2>
        <div className="phai-stats-grid">
          {pageContent.statistics.map((stat, index) => (
            <div key={index} className="phai-stat-card">
              <div className="phai-stat-chart">
                <img src={stat.chartImage} alt={stat.title} />
              </div>
              <a href={stat.sourceLink} target="_blank" rel="noopener noreferrer" className="phai-stat-source">
                {pageContent.sourceLink}
              </a>
              <h3 className="phai-stat-title">{stat.title}</h3>
              <p className="phai-stat-description">{stat.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Interactive Onboarding Section */}
      <section className="phai-onboarding-section" id="onboarding">
        <h2 className="phai-section-title">{pageContent.onboardingTitle}</h2>
        <p className="phai-section-subtitle">{pageContent.onboardingDescription}</p>
        <div className="phai-onboarding-wrapper">
          <InteractiveOnboarding translations={pageContent} />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PersonalHealthAI;
